import script from "./change_passwd.vue?vue&type=script&setup=true&lang=js"
export * from "./change_passwd.vue?vue&type=script&setup=true&lang=js"

import "./change_passwd.vue?vue&type=style&index=0&id=67ffa9c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67ffa9c4"]])

export default __exports__